module.exports = __webpack_public_path__ + "ef1bd493a91a1058bdfbf09ed5e67354.png";